import React, { useState } from 'react';
import { useAuth0 } from '@auth0/auth0-react';
import { Outlet, Link, useLocation, useNavigate } from "react-router-dom";
import Sites from '../components/handlers/Sites-handler';
import {
  Collapse,
  Navbar,
  NavbarToggler,
  NavbarBrand,
  Nav,
  NavItem,
  NavLink,
  NavbarText,
  Button
} from 'reactstrap';
import SummaryDropdown from './SummaryDropdown';

const logo = '/BergeyLogox.png';

export default function NavBar() {
  const [navOpen, setNavOpen] = useState(false);
  const [isAdminView, setIsAdminView] = useState(true); // State for toggling views
  const { loginWithRedirect, logout, isAuthenticated } = useAuth0();
  const location = useLocation();
  const navigate = useNavigate();
  
  const toggle = () => setNavOpen(!navOpen);

  const handleToggleView = () => {
    const newView = !isAdminView;
    setIsAdminView(newView);

    const currentUid = location.pathname.split('/').pop(); // Extract UID from the URL
    const newPath = newView ? `/turbine/${currentUid}` : `/mysite/${currentUid}`;
    navigate(newPath);
  };

  const renderSearchBar = () => {
    if (location.pathname === "/") {
      return <SummaryDropdown />;
    } else if (/^\/turbine(\/[a-zA-Z0-9]+)?$/.test(location.pathname)) {
      // Show Sites component for "/turbine" or "/turbine/:uid"
      return <Sites />;
    } else if (/^\/mysite(\/[a-zA-Z0-9]+)?$/.test(location.pathname)) {
      // Do not show search bar for "/mysite" or "/mysite/:uid"
      return null;
    }
    return null;
  };

  const renderSummary = () => {
    if (/^\/mysite(\/[a-zA-Z0-9]+)?$/.test(location.pathname)) {
      return null;
    } else {
      return <NavLink tag={Link} to="/">Summary</NavLink>
    }
  };


  // Check if the current route matches "/turbine/:uid" or "/mysite/:uid"
  const isToggleVisible = /^\/(turbine|mysite)\/[a-zA-Z0-9]+$/.test(location.pathname);

  return (
    <div>
      <Navbar expand="md" className="navbar-light bg-light fixed-top">
        <NavbarBrand tag={Link} to="/">
          <img src={logo} alt="Logo" style={{ height: '30px' }}/>
        </NavbarBrand>
        <NavbarToggler onClick={toggle} />
        <Collapse isOpen={navOpen} navbar>
          <Nav className="me-auto" navbar>
            <NavItem>
              {renderSummary()}
            </NavItem>
            <NavItem>
              <NavLink tag={Link} to="/turbine">Turbine</NavLink>
            </NavItem>
            <NavItem>
              <NavLink tag={Link} to="/download">Download</NavLink>
            </NavItem>
          </Nav>
          {isToggleVisible && (
            <NavbarText>
              <Button onClick={handleToggleView}>
                {isAdminView ? "Customer View" : "Admin View"}
              </Button>
            </NavbarText>
          )}
          <NavbarText className="ml-auto nav-space">
            {renderSearchBar()}
          </NavbarText>
          <NavbarText>
            {isAuthenticated ? (
              <Button onClick={() => logout({ returnTo: "/" })}>Logout</Button>
            ) : (
              <Button onClick={() => loginWithRedirect()}>Login</Button>
            )}
          </NavbarText>
        </Collapse>
      </Navbar>
      <Outlet />
    </div>
  );
}

